import { useEffect, useState, useMemo } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Plus, PencilSquare, QrCodeScan, SlashCircle } from "react-bootstrap-icons";
import Swal from 'sweetalert2';
import { QRCodeCanvas } from "qrcode.react";
import { Tabs, Tab } from "react-bootstrap";
import ConductoresTab from "../components/ConductoresTab";

import api from "../api/axios";

export default function VehiclePage() {
  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [rates, setRates] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showTotpModal, setShowTotpModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingTotp, setLoadingTotp] = useState(null);
  const [loadingDeactivate, setLoadingDeactivate] = useState(null);
  const [qrData, setQrData] = useState(null);
  const [showBulkRateModal, setShowBulkRateModal] = useState(false);
  const [bulkRateId, setBulkRateId] = useState("");
  const [loadingBulkRate, setLoadingBulkRate] = useState(false);
  const [errors, setErrors] = useState({});
  const [clearSelection, setClearSelection] = useState(false);
  const roles = JSON.parse(localStorage.getItem("roles") || "[]");
  const isTenant = roles.includes("tenant");
  
  const [formData, setFormData] = useState({
    id: null,
    tenant_id: "",
    plate: "",
    lateral: "",
    brand: "",
    model: "",
    nit: "",
    type: "",
    to_number: "",
    issued_at: "",
    expires_at: "",
    owner_name: "",
    owner_document: "",
    engine_number: "",
    chassis_number: "",
    serial_number: "",
    fuel_type: "",
    passenger_capacity: "",
    is_active: true,
    rate_id: "",
  });

  // ==============================
  // Fetch inicial
  // ==============================
  useEffect(() => {
    fetchVehicles();
    fetchTenants();
    fetchRates();
  }, []);

  const normalize = (txt) =>
    txt?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const fetchVehicles = async () => {
    try {
      setLoadingTable(true);
      const res = await api.get("/vehicles/list");
      setVehicles(res.data.data);
      setFilteredVehicles(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingTable(false);
    }
  };

  const fetchTenants = async () => {
    try {
      const res = await api.get("/tenants/accessible");
      setTenants(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchRates = async () => {
    try {
      const res = await api.get("/rates/accessible");
      setRates(res.data.data);
      
    } catch (err) {
      console.error(err);
    }
  };

  const recentRates = useMemo(() => {
    return rates
      .filter(r => r.status === "published")
      .sort(
        (a, b) =>
          new Date(b.published_at) - new Date(a.published_at)
      )
      .slice(0, 2); // 👈 solo las 2 últimas
  }, [rates]);

  console.log(recentRates);

  // ==============================
  // Filtrar //
  // ==============================
  useEffect(() => {
    const term = normalize(search).trim();
    const result = vehicles.filter((v) => {
      // ======================
      // BÚSQUEDA POR TEXTO
      // ======================
      const matchesText =
        normalize(v.plate)?.includes(term) ||
        normalize(v.lateral)?.includes(term) ||
        normalize(v.brand)?.includes(term) ||
        normalize(v.model)?.includes(term) ||
        normalize(v.tenant?.name)?.includes(term) ||
        normalize(v.rate?.display_name)?.includes(term);

      // ======================
      // BÚSQUEDA POR ESTADO
      // ======================
      const matchesStatus =
        ("activo".startsWith(term) && v.is_active === true) ||
        ("inactivo".startsWith(term) && v.is_active === false);


      // 👇 si el input está vacío, muestra todo
      if (!term) return true;

      // 👇 prioriza estado si coincide exactamente
      if ("activo".startsWith(term) || "inactivo".startsWith(term)) {
        return matchesStatus;
      }

      return matchesText;
    });

    setFilteredVehicles(result);
  }, [search, vehicles]);



  // ==============================
  // Modal Nuevo
  // ==============================
  const handleShowNew = () => {
    setIsEditing(false);
    setErrors({});
    setFormData({
      id: null,
      tenant_id: "",
      plate: "",
      lateral: "",
      brand: "",
      model: "",
      nit: "",
      type: "",
      to_number: "",
      issued_at: "",
      expires_at: "",
      owner_name: "",
      owner_document: "",
      engine_number: "",
      chassis_number: "",
      serial_number: "",
      fuel_type: "",
      passenger_capacity: "",
      is_active: true,
      rate_id: "",
    });
    setShowModal(true);
  };

  // ==============================
  // Modal Editar
  // ==============================
  const handleShowEdit = (v) => {
    setIsEditing(true);
    setErrors({});
    setFormData({
      id: v.id,
      tenant_id: v.tenant_id,
      plate: v.plate,
      lateral: v.lateral,
      brand: v.brand,
      model: v.model,
      nit: v.nit,
      type: v.type,
      to_number: v.to_number,
      issued_at: v.issued_at,
      expires_at: v.expires_at,
      owner_name: v.owner_name,
      owner_document: v.owner_document,
      engine_number: v.engine_number,
      chassis_number: v.chassis_number,
      serial_number: v.serial_number,
      fuel_type: v.fuel_type,
      passenger_capacity: v.passenger_capacity,
      is_active: v.is_active,
      rate_id: v.rate_id,
    });

    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setIsEditing(false);
  };

  // ==============================
  // Guardar
  // ==============================
  const handleSave = async () => {
    setLoadingSave(true);
    setErrors({});

    const payload = {
      ...formData,
      plate: formData.plate?.toUpperCase() ?? "",
      brand: formData.brand?.toUpperCase() ?? "",
      model: formData.model?.toUpperCase() ?? "",
      lateral: formData.lateral?.toUpperCase() ?? "",
      type: formData.type?.toUpperCase() ?? "",
      owner_name: formData.owner_name?.toUpperCase() ?? "",
    };

    try {
      if (isEditing) {
        await api.put(`/vehicles/update/${formData.id}`, payload);
      } else {
        await api.post("/vehicles/create", payload);
      }
      handleClose();
      fetchVehicles();
    } catch (err) {
      if (err.response?.status === 422) {
        setErrors(err.response.data.errors);
      } else {
        Swal.fire({
            title: 'Error',
            text: "Error desconocido al guardar",
            icon: 'error',
            timer: 1500,
            showConfirmButton: false
        });
      }
    } finally {
      setLoadingSave(false);
    }
  };

  const generateQR = async (row) => {
    setLoadingTotp(row.id);
    try {

      // 📌 Enviar JSON correctamente
      const res = await api.post("/devices/register/start", {
        vehicle_plate: row.plate,
      });

      // 📌 Axios devuelve respuesta en res.data
      const json = res.data;

      const payload = {
        vehicle: json.vehicle,
        token: json.token
      };

      setQrData(JSON.stringify(payload));
      setShowTotpModal(true);

    } catch (err) {
        console.error(err);
        Swal.fire({
            title: 'Error',
            text: "Error: " + (err.response?.data?.message || err.message),
            icon: 'error',
            timer: 1500,
            showConfirmButton: false
        });
    } finally {
      setLoadingTotp(null);
    }
  };

  const handleCloseModal = () => {
    setShowTotpModal(false);
    setQrData("");
    fetchVehicles(); // refresca tabla principal
  };

  const deactivateDevice = async (row) => {
    if (!row.device) return;

    setLoadingDeactivate(row.id);

    try {
      await api.post(`/devices/${row.device.id}/deactivate`);

      // 🔄 refrescar tabla (recomendado)
      await fetchVehicles();

    } catch (err) {
      console.error(err);
      alert("No fue posible desactivar el dispositivo.");
    } finally {
      setLoadingDeactivate(null);
    }
  };

  const confirmDeactivate = async (row) => {
    const res = await Swal.fire({
      title: "¿Desactivar dispositivo?",
      text: "El vehículo quedará sin dispositivo activo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, desactivar",
      cancelButtonText: "Cancelar",
    });

    if (res.isConfirmed) {
      deactivateDevice(row);
    }
  };

  const applyBulkRate = async () => {
    if (!bulkRateId || selectedVehicles.length === 0) return;

    const res = await Swal.fire({
      title: "¿Cambiar tarifa masivamente?",
      html: `Se actualizarán <b>${selectedVehicles.length}</b> vehículos.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
    });

    if (!res.isConfirmed) return;

    try {
      setLoadingBulkRate(true);

      await api.post("/vehicles/update-bulk-rate", {
        vehicle_ids: selectedVehicles.map(v => v.id),
        rate_id: Number(bulkRateId),
      });

      Swal.fire({
        title: "Listo",
        text: "Tarifa actualizada correctamente.",
        icon: "success",
        timer: 1400,
        showConfirmButton: false,
      });

      setShowBulkRateModal(false);
      setBulkRateId("");
      setSelectedVehicles([]);
      
      // 🔥 fuerza limpieza visual del DataTable
      setClearSelection(prev => !prev);

      await fetchVehicles();
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: "Error",
        text: err.response?.data?.message || "No fue posible actualizar la tarifa.",
        icon: "error",
      });
    } finally {
      setLoadingBulkRate(false);
    }
  };

  // ==============================
  // Columnas tabla
  // ==============================
  const columns = [
    { name: "Empresa", selector: (row) => row.tenant?.name, sortable: true, grow: 2 },
    { name: "Placa", selector: (row) => row.plate, sortable: true, grow: 1 },
    { name: "Marca", selector: (row) => row.brand, sortable: true, grow: 1 },
    { name: "Lateral", selector: (row) => row.lateral, sortable: true, grow: 1 },
    { name: "Modelo", selector: (row) => row.model, sortable: true, grow: 1 },
    { name: "Tarifa", selector: (row) => row.rate?.display_name, sortable: true, grow: 2.5 },
    {
      name: "Estado",
      cell: (row) => (
        <span
          className={`badge ${row.is_active ? "bg-success" : "bg-danger"}`}
        >
          {row.is_active ? "Activo" : "Inactivo"}
        </span>
      ),
    },
    {
      name: "Opciones",
      cell: (row) => (
        <div className="d-flex gap-2">
            <Button
                variant="outline-info"
                size="sm"
                onClick={() => handleShowEdit(row)}
            >
                <PencilSquare />
            </Button>

            {/* SOLO SI EL USUARIO NO ES TENANT */}
            {!isTenant && (
              <>
                {!row.device && row.is_active && (
                  <Button
                      variant="outline-warning"
                      size="sm"
                      disabled={loadingTotp === row.id}
                      onClick={() => generateQR(row)}
                  >
                      {loadingTotp === row.id ? (
                          <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                          <QrCodeScan />
                      )}
                  </Button>
                )}

                {/* 2️⃣ Vehículo activo CON dispositivo ACTIVO */}
                {row.is_active && row.device && row.device.status === "active" && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    disabled={loadingDeactivate === row.id}
                    onClick={() => confirmDeactivate(row)}
                    title="Desactivar dispositivo actual"
                  >
                    {loadingDeactivate === row.id ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      <SlashCircle />
                    )}
                  </Button>
                )}

                {/* 3️⃣ Vehículo activo CON dispositivo INACTIVO */}
                {row.is_active && row.device && row.device.status !== "active" && (
                  <Button
                    variant="outline-warning"
                    size="sm"
                    disabled={loadingTotp === row.id}
                    onClick={() => generateQR(row)}
                    title="Vincular nuevo dispositivo"
                  >
                    {loadingTotp === row.id ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      <QrCodeScan />
                    )}
                  </Button>
                )}
              </>
            )}
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <div className="mt-4">
      {/* TABLA */}
      <DataTable
        selectableRows
        onSelectedRowsChange={({ selectedRows }) =>
          setSelectedVehicles(selectedRows)
        }
        clearSelectedRows={clearSelection}
        title="Vehículos"
        columns={columns}
        data={filteredVehicles}
        pagination
        highlightOnHover
        striped
        progressPending={loadingTable}
        progressComponent={
          <div className="text-center p-3">
            <div className="spinner-border text-primary"></div>
            <p>Cargando...</p>
          </div>
        }
        subHeader
        subHeaderComponent={
  <div className="d-flex justify-content-between w-100 align-items-center">
    <div className="d-flex gap-2">
      <Button variant="outline-success" size="sm" onClick={handleShowNew}>
        Nuevo <Plus />
      </Button>

      <Button
        variant="outline-primary"
        size="sm"
        disabled={selectedVehicles.length === 0}
        onClick={() => setShowBulkRateModal(true)}
        title="Cambiar tarifa a los vehículos seleccionados"
      >
        Cambiar tarifa ({selectedVehicles.length})
      </Button>
    </div>

    <input
      type="text"
      className="form-control w-25"
      placeholder="Buscar..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>
}

      />

      {/* MODAL */}
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Editar Vehículo" : "Nuevo Vehículo"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Tabs defaultActiveKey="vehicle" id="vehicle-tabs" className="mb-3" navClassName="d-flex justify-content-start">

            {/* =======================
                PESTAÑA: DATOS VEHÍCULO
              ======================= */}
            <Tab eventKey="vehicle" title="Datos del vehículo">
              <Form>
                {/* Empresa */}
                <Form.Group className="mb-3">
                  <Form.Label>Empresa</Form.Label>
                  <Form.Select
                    value={formData.tenant_id}
                    onChange={(e) =>
                      setFormData({ ...formData, tenant_id: e.target.value })
                    }
                  >
                    <option value="">Seleccionar...</option>
                    {tenants.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.tenant_id?.map((e, i) => (
                    <Form.Text key={i} className="text-danger d-block">
                      {e}
                    </Form.Text>
                  ))}
                </Form.Group>

                <div className="row">
                  <Form.Group className="mb-3 col-6">
                    <Form.Label>Placa</Form.Label>
                    <Form.Control
                      value={formData.plate}
                      onChange={(e) =>
                        setFormData({ ...formData, plate: e.target.value })
                      }
                    />
                    {errors.plate?.map((e, i) => (
                      <Form.Text key={i} className="text-danger">
                        {e}
                      </Form.Text>
                    ))}
                  </Form.Group>

                  <Form.Group className="mb-3 col-6">
                    <Form.Label>Lateral</Form.Label>
                    <Form.Control
                      value={formData.lateral}
                      onChange={(e) =>
                        setFormData({ ...formData, lateral: e.target.value })
                      }
                    />
                    {errors.lateral?.map((e, i) => (
                      <Form.Text key={i} className="text-danger">
                        {e}
                      </Form.Text>
                    ))}
                  </Form.Group>
                </div>

                <div className="row">
                  <Form.Group className="mb-3 col-6">
                    <Form.Label>Marca</Form.Label>
                    <Form.Control
                      value={formData.brand}
                      onChange={(e) =>
                        setFormData({ ...formData, brand: e.target.value })
                      }
                    />
                    {errors.brand?.map((e, i) => (
                      <Form.Text key={i} className="text-danger">
                        {e}
                      </Form.Text>
                    ))}
                  </Form.Group>

                  <Form.Group className="mb-3 col-6">
                    <Form.Label>Modelo</Form.Label>
                    <Form.Control
                      value={formData.model}
                      onChange={(e) =>
                        setFormData({ ...formData, model: e.target.value })
                      }
                    />
                    {errors.model?.map((e, i) => (
                      <Form.Text key={i} className="text-danger">
                        {e}
                      </Form.Text>
                    ))}
                  </Form.Group>
                </div>

                <div className="row">
                    <Form.Group className="mb-3 col-6">
                        <Form.Label>Tipo</Form.Label>
                        <Form.Control
                            value={formData.type}
                            onChange={(e) =>
                            setFormData({ ...formData, type: e.target.value })
                            }
                        />
                        {errors.type?.map((e, i) => (
                            <Form.Text key={i} className="text-danger">
                                {e}
                            </Form.Text>
                        ))}
                    </Form.Group>

                    {/* Campos opcionales */}
                    <Form.Group className="mb-3 col-6">
                        <Form.Label>NIT</Form.Label>
                        <Form.Control
                            value={formData.nit}
                            onChange={(e) =>
                            setFormData({ ...formData, nit: e.target.value })
                            }
                        />
                    </Form.Group>
                </div>
                
                <div className="row">
                    <Form.Group className="mb-3 col-4">
                        <Form.Label>Número Tarjeta de Operación</Form.Label>
                        <Form.Control
                            value={formData.to_number}
                            onChange={(e) =>
                            setFormData({ ...formData, to_number: e.target.value })
                            }
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3 col-4">
                        <Form.Label>Fecha de expedicón</Form.Label>
                        <Form.Control
                        type="date"
                        value={formData.issued_at}
                        onChange={(e) =>
                            setFormData({ ...formData, issued_at: e.target.value })
                        }
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4">
                        <Form.Label>Fecha de vencimiento</Form.Label>
                        <Form.Control
                        type="date"
                        value={formData.expires_at}
                        onChange={(e) =>
                            setFormData({ ...formData, expires_at: e.target.value })
                        }
                        />
                    </Form.Group>
                </div>
                
                <div className="row">
                    <Form.Group className="mb-3 col-6">
                        <Form.Label>Propietario</Form.Label>
                        <Form.Control
                            value={formData.owner_name}
                            onChange={(e) =>
                            setFormData({ ...formData, owner_name: e.target.value })
                            }
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-6">
                        <Form.Label>Documento propietario</Form.Label>
                        <Form.Control
                            value={formData.owner_document}
                            onChange={(e) =>
                            setFormData({ ...formData, owner_document: e.target.value })
                            }
                        />
                    </Form.Group>
                </div>

                <div className="row">
                    <Form.Group className="mb-3 col-4">
                        <Form.Label>Motor</Form.Label>
                        <Form.Control
                            value={formData.engine_number}
                            onChange={(e) =>
                            setFormData({ ...formData, engine_number: e.target.value })
                            }
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4">
                        <Form.Label>Chasis</Form.Label>
                        <Form.Control
                            value={formData.chassis_number}
                            onChange={(e) =>
                            setFormData({ ...formData, chassis_number: e.target.value })
                            }
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4">
                        <Form.Label>Serie</Form.Label>
                        <Form.Control
                            value={formData.serial_number}
                            onChange={(e) =>
                            setFormData({ ...formData, serial_number: e.target.value })
                            }
                        />
                    </Form.Group>
                </div>

                <div className="row">
                    <Form.Group className="mb-3 col-6">
                        <Form.Label>Combustible</Form.Label>
                        <Form.Control
                            value={formData.fuel_type}
                            onChange={(e) =>
                            setFormData({ ...formData, fuel_type: e.target.value })
                            }
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-6">
                        <Form.Label>Capacidad Pasajeros</Form.Label>
                        <Form.Control
                            type="number"
                            value={formData.passenger_capacity}
                            onChange={(e) =>
                            setFormData({
                                ...formData,
                                passenger_capacity: e.target.value,
                            })
                            }
                        />
                    </Form.Group>
                </div>
                {/* Estado */}
                <Form.Check
                  type="checkbox"
                  label="Activo"
                  checked={formData.is_active}
                  onChange={(e) =>
                    setFormData({ ...formData, is_active: e.target.checked })
                  }
                />
                <div className="d-flex justify-content-end gap-2">
                  <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                  </Button>

                  <Button variant="primary" onClick={handleSave} disabled={loadingSave}>
                    {loadingSave ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Guardando...
                      </>
                    ) : isEditing ? (
                      "Actualizar"
                    ) : (
                      "Guardar"
                    )}
                  </Button>
                </div>
              </Form>
              
              
            </Tab>

            {/* =======================
                PESTAÑA: CONDUCTORES
              ======================= */}
            <Tab
              eventKey="drivers"
              title="Conductores"
              disabled={!isEditing} // Solo disponible al editar
            >
              {!isEditing ? (
                <p className="text-muted">
                  Debes crear el vehículo antes de asignar conductores.
                </p>
              ) : (
                <>
                  <ConductoresTab vehicleId={formData.id} />
                </>
              )}
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>

      <Modal show={showTotpModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
            <Modal.Title>Registro de dispositivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {qrData && (
                <>
                    <div className="text-center mb-3">
                        <QRCodeCanvas
                            value={qrData}
                            size={230}
                            level="H"
                            bgColor="#ffffff"
                            fgColor="#000000"
                        />
                    </div>

                    <p className="text-muted">
                        Escanee este código con la app de <strong>Taximetro</strong>.
                    </p>
                </>
            )}
        </Modal.Body>
      </Modal>

            {/* MODAL CAMBIO MASIVO TARIFA */}
      <Modal show={showBulkRateModal} onHide={() => setShowBulkRateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar tarifa a vehículos</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-muted">
            Vehículos seleccionados: <strong>{selectedVehicles.length}</strong>
          </p>

          <Form.Group>
            <Form.Label>Tarifa nueva</Form.Label>
            <Form.Select
              value={bulkRateId}
              onChange={(e) => setBulkRateId(Number(e.target.value))}
            >
              <option value="">Seleccionar tarifa…</option>
              {recentRates.map(r => (
                <option key={r.id} value={r.id}>
                  {r.display_name}
                </option>
              ))}
            </Form.Select>

          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBulkRateModal(false)}>
            Cancelar
          </Button>

          <Button
            variant="primary"
            disabled={!bulkRateId || selectedVehicles.length === 0 || loadingBulkRate}
            onClick={applyBulkRate}
          >
            {loadingBulkRate ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Aplicando...
              </>
            ) : (
              "Confirmar"
            )}
          </Button>
        </Modal.Footer>
      </Modal>


    </div>
  );
}
